<template>
  <forecastsReportsPage
    :category="category"
    :category-report="forecastSubscription"
    :product="slug"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import forecastsReportsPage from '~/components/shared/forecasts/ReportsPage.vue'
import type { TProduct } from '~/src/types/product'

const props = withDefaults(
  defineProps<{
    product: TProduct
    forecastSubscription?: string
  }>(),
  {
    forecastSubscription: '',
  },
)

const category = computed(() => props.product.category)
const slug = computed(() => props.product.slugForecast || props.product.slug)
</script>
